<template>
  <BaseChartPanel
    :title="t('news_dynamic_chart.title')"
    :date="date"
    :chart-height="stylesChart.heightAreaChart"
    :chart-key="`${selectedChart}-${refreshCounter}`"
    :chart-options="chartOptions"
    :series="series?.[0]?.named ? toRaw(series) : []"
    @refresh="loadData"
    @update:date="date = $event"
  >
    <template #controls>
      <ChartFilterDropdown
        v-model:chart-type="selectedChart"
        :active-store="activeStore"
        :date="date"
        all-enabled
        send-param-name
        stop-load-on-clear
        @clear="clearRubrics"
      />
    </template>
  </BaseChartPanel>
</template>

<script setup>
import { computed, ref, toRaw } from "vue";
import { useNewsStatDynamicBlocksStore } from "@/store/Analytic/chart/news-stat-dynamic-blocks";
import { useNewsStatDynamicRubricStore } from "@/store/Analytic/chart/news-stat-dynamic-rubric";
import { useRubricsStore } from "@/store/NewsFeed/rubrics";
import { useThemesStore } from "@/store/NewsFeed/themes";
import { stylesChart } from "@/tools/tooltipChart";
import ChartFilterDropdown from "./blocks/ChartFilterDropdown.vue";
import useAreaChart from "@/mixins/apexChart/areaChart";
import useFilterDate from "@/mixins/apexChart/filterDate";
import { t } from "@/controllerLK/AvalLocalization";
import BaseChartPanel from "./BaseChartPanel.vue";

const { date } = useFilterDate(loadData);
const selectedChart = ref(0);
const refreshCounter = ref(0);

const statStorage = useNewsStatDynamicBlocksStore();
const statRubricStorage = useNewsStatDynamicRubricStore();
const rubricsStore = useRubricsStore();
const themesStore = useThemesStore();

const activeStore = computed(() => {
  return selectedChart.value === 0 ? statStorage : statRubricStorage;
});

const series = computed(() => {
  const kind = selectedChart.value === 0 ? themesStore.allThemes : rubricsStore.allRubrics;
  return (activeStore.value.items || [])
    .filter((item) => {
      // Фильтруем элементы, для которых найдено соответствующее имя темы/рубрики (задача 1772)
      const foundName = kind.find((theme) => theme.id == item.name);
      return foundName && foundName.name;
    })
    .map((item) => {
      const name = kind.find((theme) => theme.id == item.name)?.name;
      return {
        name: name,
        data: item.data.map((point) => point.count),
        named: name // Для проверки, что имя из стора, а не item.name (ID).
      };
    });
});

const categories = computed(() => {
  const labelsSet = new Set();
  (activeStore.value.items || []).forEach((item) => {
    item.data.forEach((point) => {
      labelsSet.add(point.date);
    });
  });
  return Array.from(labelsSet).sort((a, b) => new Date(a) - new Date(b));
});

const { chartOptions } = useAreaChart(
  {
    titleText: t("news_dynamic_chart.title"),
  },
  categories,
  series
);

async function loadData() {
  await statStorage.loadStat(date.value[0], date.value[1]);
  await statRubricStorage.loadStat(date.value[0], date.value[1]);
}

const clearRubrics = () => {
  statStorage.items = [];
  statRubricStorage.items = [];
  refreshCounter.value++;
  chartOptions.value = {
    ...chartOptions.value,
    noData: { text: t("common_chart.no_data.short_text") },
  };
};
</script>
